import { AxiosPromise } from 'axios';

import { IQuizSubmitPayload } from 'pages/QuizPage/quiz.types';
import { api } from './api';

/**
 * Endpoints related to the FO quiz pages (`/fo/form/{id}`).
 *
 * The legacy API resource is still named `Form` (Doctrine entity), but on the
 * front it is exposed to the user as a "quiz", hence the `QuizAPI` naming.
 *
 * Routes are exposed by API Platform on the `Form` resource:
 *  - `GET /forms/{id}/user`   → quiz payload (form:user group). 403 when not targeted.
 *  - `GET /forms/{id}/latest` → latest entry (formEntry:latest). 204 when none yet.
 *  - `POST /form-entries`     → submit a new entry.
 */
export class QuizAPI {
  static getUserQuiz(quizId: number): AxiosPromise {
    return api.get(`/forms/${quizId}/user.jsonld`);
  }

  static getLatestUserQuizEntry(quizId: number): AxiosPromise {
    return api.get(`/forms/${quizId}/latest.jsonld`);
  }

  static submitEntry(payload: IQuizSubmitPayload): AxiosPromise {
    return api.post('/form-entries.jsonld', payload);
  }
}
